function activate(items, index) {
  items.forEach((el, i) => {
    el.classList.toggle('active', i === index);
    if (el.hasAttribute('aria-pressed')) {
      el.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    }
  });
}

function bind(event, triggers, groups) {
  triggers.forEach((trigger, i) => {
    trigger.addEventListener(event, () => groups.forEach(group => activate(group, i)));
  });
}

export default function case_page() {
  // Якорі першого екрана кейсу: плавна прокрутка замість стрибка.
  document.querySelectorAll('.case_hero a[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) {
        return;
      }

      e.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', link.getAttribute('href'));
    });
  });

  document.querySelectorAll('.js-case-stages').forEach(root => {
    const bars = root.querySelectorAll('.case_bar_btn');
    const stages = root.querySelectorAll('.case_stage');

    bind('click', bars, [bars, stages]);
    bind('mouseenter', stages, [bars, stages]);

    // Етап посередині екрана стає активним разом із відрізком смуги.
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const i = Array.prototype.indexOf.call(stages, entry.target);
            activate(bars, i);
            activate(stages, i);
          }
        });
      }, { rootMargin: '-45% 0px -45% 0px' });

      stages.forEach(stage => observer.observe(stage));
    }
  });

  document.querySelectorAll('.js-case-spots').forEach(root => {
    const spots = root.querySelectorAll('.case_spot');
    const notes = root.querySelectorAll('.case_spot_note');

    bind('click', spots, [spots, notes]);
    bind('mouseenter', spots, [spots, notes]);
  });

  document.querySelectorAll('.js-case-form').forEach(form => {
    const button = form.querySelector('button[type="submit"]');
    const success = form.parentElement.querySelector('.case_cta_success');
    const phone = form.elements.phone;

    form.addEventListener('submit', e => {
      e.preventDefault();

      phone.parentElement.classList.toggle('error', !phone.value.trim());
      if (!phone.value.trim()) {
        return;
      }

      const caseHero = document.querySelector('[data-case-title]');
      const page = `Сторінка: ${window.location.href}`;

      button.disabled = true;
      fetch(form.getAttribute('action'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          phone: phone.value,
          comment: caseHero ? `Кейс: ${caseHero.dataset.caseTitle}, ${page}` : page,
        }),
      })
        .then(response => response.json())
        .then(() => {
          form.reset();
          form.hidden = true;
          success.hidden = false;

          setTimeout(() => {
            form.hidden = false;
            success.hidden = true;
          }, 3000);
        })
        .finally(() => {
          button.disabled = false;
        });
    });
  });

  document.querySelectorAll('.js-cases').forEach(root => {
    const chips = root.querySelectorAll('.cases_chip');
    const cards = root.querySelectorAll('.cases_card');
    const bar = root.querySelector('.cases_filter_bar');
    const body = root.querySelector('.cases_body');

    chips.forEach((chip, i) => {
      chip.addEventListener('click', () => {
        activate(chips, i);
        cards.forEach(card => {
          card.hidden = chip.dataset.filter !== 'all' && card.dataset.category !== chip.dataset.filter;
        });

        // Якщо фільтр прилип, повертаємо на початок результатів.
        const barBottom = bar.getBoundingClientRect().bottom;
        if (body.getBoundingClientRect().top < barBottom) {
          window.scrollTo({ top: body.getBoundingClientRect().top + window.scrollY - barBottom });
        }
      });
    });
  });
}
